function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { useEffect, useState } from 'react';
/**
 * 
 * @param ref A ref to the element whose index we want to find
 * @returns It's index in the parent's children array & length of the parent's children array
 */ const useChildIndex = (ref)=>{
    const [childIndex, setChildIndex] = useState(null);
    useEffect(()=>{
        if (ref.current) {
            let parent = ref.current.parentElement;
            if (parent) {
                let me = ref.current;
                let children = Array.from(parent.children);
                if (children.length === 1) {
                    me = parent;
                    parent = parent.parentElement;
                    if (parent) {
                        children = Array.from(parent.children);
                    }
                }
                let index = children.indexOf(me);
                setChildIndex({
                    index,
                    length: children.length
                });
            }
        }
    }, [
        ref
    ]);
    return childIndex ? _object_spread_props(_object_spread({}, childIndex), {
        isFirst: childIndex.index === 0,
        isLast: childIndex.index === childIndex.length - 1
    }) : null;
};
export default useChildIndex;
